/**
 * Created by bob.gear on 25/05/2017.
 */
// See also: README.md#http-interceptor-architecture-hybrid

const getRequestPath = function (url) {
  try {
    return new URL(url, window.location.origin).pathname || '';
  } catch (e) {
    return (url || '').split('?')[0].split('#')[0];
  }
};

const hasPathPrefix = function (url, prefix) {
  return getRequestPath(url).startsWith(prefix);
};

const isUnauthorizedStatus = function (status) {
  return status === 401;
};

const hasHeader = function (headers, headerName) {
  if (!headers) return false;

  const target = (headerName || '').toLowerCase();
  return Object.keys(headers).some(key => key.toLowerCase() === target);
};

const ensureJsonContentType = function (request) {
  if (!request || request.data === undefined || request.data === null) return;
  request.headers = request.headers || {};

  if (!hasHeader(request.headers, 'Content-Type')) {
    request.headers['Content-Type'] = 'application/json;charset=utf-8';
  }
};

export const EICDataStreamAuthorization = angular.module("EICDataStream3.HttpInterceptors",
  [
    "ui.router",
    'ngStorage',
    "ivpusic.cookie",
    "EICDataStream3.config",
  ])


  .factory('bffInterceptor',
    [
      function () {
        // AngularJS ($http) interceptor for native /bff/* requests.
        // Why it exists: this hybrid app still issues requests from AngularJS,
        // so BFF cookie + CSRF requirements must be enforced in both stacks.
        return {
          'request': function (request) {

            // For BFF calls, include session cookie and anti-CSRF marker.
            // Merge headers to avoid removing caller-provided headers.
            if (hasPathPrefix(request.url, '/bff/')) {
              request.withCredentials = true;
              request.headers = request.headers || {};
              request.headers['X-CSRF'] = '1';
              ensureJsonContentType(request);
            }

            // Non-BFF traffic is untouched.
            return request;
          },
        };
      }
    ])
  .factory('apiToBffInterceptor',
    [
      '$q',
      function ($q) {
        // AngularJS interceptor for API-family requests that are handled behind
        // BFF policy. Also centralizes 401 redirect behavior for $http callers.
        return {
          'request': function (request) {
            // For API routes, enforce the same cookie + CSRF requirements used
            // by BFF endpoints.
            const isApiFamilyRequest = ['/api/', '/umn/', '/mdb/', '/akm/'].some(
              prefix => hasPathPrefix(request.url, prefix)
            );

            if (isApiFamilyRequest) {
              request.withCredentials = true;
              request.headers = request.headers || {};
              request.headers['X-CSRF'] = '1';
              ensureJsonContentType(request);
            }

            // Non-API traffic is untouched.
            return request;
          },
          'responseError': function (response) {
            if (isUnauthorizedStatus(response.status)) {
              // Redirect to login and preserve return path for post-login resume.
              window.top.location.href = `/bff/login?returnUrl=${window.top.location.pathname}`;

              // Important: re-reject so callers still observe an error in case
              // navigation is blocked or delayed.
              return $q.reject(response);
            }

            // For all other errors (e.g. 503, 404, 400), propagate rejection.
            return $q.reject(response);
          }
        };
      }
    ])

  .factory('versionCacheBustInterceptor',
    [
      'APP_META',
      function (APP_META) {
        // Purpose:
        // - Append appVersion as a query string to static file requests (HTML,
        //   templates, etc.) to force browser cache invalidation on new builds.
        // - Targets non-API requests that typically return static content.
        const staticFileExtensions = ['.html', '.htm', '.tpl', '.template'];
        const appVersion = APP_META.appVersion || 'unknown';

        return {
          'request': function (request) {
            const requestPath = getRequestPath(request.url);
            const isStaticFile = staticFileExtensions.some(ext => requestPath.endsWith(ext));
            const isTemplateCachePath = requestPath.startsWith('/templates/') ||
              requestPath.startsWith('/template/') ||
              requestPath.startsWith('templates/') ||
              requestPath.startsWith('template/');
            const isUiBootstrapPath = requestPath.startsWith('/uib/') ||
              requestPath.startsWith('uib/');

            // Skip if this is an API family request or already has a cache-bust parameter.
            const isApiRequest = ['/api/', '/umn/', '/mdb/', '/akm/', '/bff/'].some(
              prefix => hasPathPrefix(request.url, prefix)
            );
            const hasVersionParam = request.url.includes('v=');

            if (isStaticFile && !isTemplateCachePath && !isUiBootstrapPath && !isApiRequest && !hasVersionParam) {
              const separator = request.url.includes('?') ? '&' : '?';
              request.url = request.url + separator + 'v=' + encodeURIComponent(appVersion);
            }

            // Pass through unchanged.
            return request;
          }
        };
      }
    ]);
